// Static page data — kept separate from components (deep module: one place to edit)

export const ledgerRows = [
  { client: 'Studio Nour', amt: '4,200', status: 'paid' },
  { client: 'Kite Agency', amt: '1,850', status: 'pending' },
  { client: 'Basma Store', amt: '3,100', status: 'paid' },
  { client: 'Reef Co.', amt: '2,760', status: 'paid' }
];

export const ledgerTargetTotal = 7300;

export const stats = [
  { label: 'invoices sent', target: 2400 },
  { label: 'freelancers on Daftari', target: 150 },
  { label: 'currencies supported', target: 9 },
  { label: 'avg. hours saved / month', target: 48 }
];